module.exports = __webpack_public_path__ + "media/images/icon-spread-normal@3x-27e098729d2a44c1bc89f98226659af9.png";